import { useTranslation } from "react-i18next";
import React, { Fragment, useRef, useState } from "react";
import {
  Typography,
  Button,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  TableSortLabel,
  TextField,
  Grid,
  MenuItem,
  Chip,
  useTheme,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Alert } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import SettingsIcon from "@mui/icons-material/Settings";
import EditIcon from "@mui/icons-material/Edit";
function descendingComparator(a, b, orderby,spalte) {
  if (spalte?.art==="date"){
    //wenn spalten.art="date" dann  das Datum im Format YYYYMMDD vergleichen
    if (b[orderby].substring(6,10)+b[orderby].substring(3,5)+b[orderby].substring(0,2) < a[orderby].substring(6,10)+a[orderby].substring(3,5)+a[orderby].substring(0,2) ) {
      return -1;
    }
    if (b[orderby].substring(6,10)+b[orderby].substring(3,5)+b[orderby].substring(0,2) > a[orderby].substring(6,10)+a[orderby].substring(3,5)+a[orderby].substring(0,2) ) {
      return 1;
    }
  }else {
  if (b[orderby] < a[orderby]) {
    return -1;
  }
  if (b[orderby] > a[orderby]) {
    return 1;
  }
}
  return 0;
}
function getComparator(order, orderby,spalte) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderby,spalte)
    : (a, b) => -descendingComparator(a, b, orderby,spalte);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function DynamicTable(props) {
  const { t } = useTranslation();
  const {
    title,
    options,
    spalten,
    zeilen,
    hoehe,
    buttonCb,
    leertext,
    minbreite,
    size,
    suche,
    zeilenklickbar,
    textsuchvorgabe,
  } = props;
  const theme = useTheme()
  const div_hoehe = hoehe ? hoehe : 400;
  const refTabelle = useRef();
  const [orderby, setOrderby] = useState("");
  const [order, setOrder] = useState("asc");
  const keineZeilen = leertext ? leertext : "Es wurden keine Einträge gefunden";
  const tbl_zeilen = !zeilen ? [] : zeilen;
  const tbl_spalten = !spalten ? [] : spalten;
  const [textsuche, setTextSuche] = useState(
    textsuchvorgabe ? textsuchvorgabe : ""
  );
  const [suchenach, setSucheNach] = useState("keineAuswahl");
  const verbunden = useRef(0);
  const [auswahlZeile, setAuswahlZeile] = useState("");

  const fitlerByType = (element) => {
    var result;
    result = false;
    var value = "";
    if (suchenach !== "keineAuswahl") {
      value = element?.[suchenach];
      if (element?.[suchenach]?.bez) {
        value = element?.[suchenach]?.bez;
      }
      if (value?.toLowerCase().includes(textsuche.toLowerCase())) {
        result = true;
      }
    }
    if (suchenach === "keineAuswahl") {
      if (tbl_spalten) {
        {
          tbl_spalten?.map((column) => {
            if (column.art !== "button" && column.art !== "status") {
              value = element?.[column?.key];
              if (element?.[column?.key]?.bez) {
                value = element?.[suchenach]?.bez;
              }
              if (element?.[column?.key]?.text) {
                value = element?.[suchenach]?.text;
              }
              if (value?.toLowerCase().includes(textsuche?.toLowerCase())) {
                return (result = true);
              }
            }
          });
        }
      }
    }
    if (textsuche === "") {
      result = true;
    }
    return result;
  };

  const setze_orderby = (column) => {
    if (column === orderby) {
      if (order === "asc") {
        setOrder("desc");
      }
      if (order === "desc") {
        setOrder("asc");
      }
    } else {
      setOrderby(column);
      setOrder("asc");
    }
  };

  const klick_event = (event, spalte, zeile, count) => {
    if (spalte === "zeile" && !zeilenklickbar) return;
    setAuswahlZeile(zeile);
    event.stopPropagation();
    buttonCb(spalte, zeile, count);
  };

  const buildGrid = () => {
    if (!tbl_spalten) return;
    var anzahl = 0;
    tbl_spalten.forEach((item) => {
      if (item.breite) {
        anzahl = anzahl + Number(item.breite);
      } else {
        anzahl = anzahl + 1;
      }
    });

    if (anzahl > 31) {
      anzahl = 31;
    }
    var scroll = refTabelle?.current?.scrollWidth;
    if (scroll < minbreite) {
      scroll = minbreite;
    }
    var len = Math.trunc((scroll - scroll / 10) / Math.max(anzahl, 1));
    return (
      <TableContainer style={{ height: div_hoehe, width: "100%" }}>
        <Table stickyHeader size={size}>
          <TableHead>
            <TableRow>
              {tbl_spalten.map((column) => (
                <TableCell
                  key={column.key}
                  id={column.key}
                  style={{
                    minWidth:
                      column && column.breite
                        ? Number(column.breite) * len
                        : len,
                  }}
                >
                  {column.art === "button" && !column.typ ? (
                    <Typography> </Typography>
                  ) : column.art === "status" ? (
                    <Typography>{column.bez}</Typography>
                  ) : column?.keinsort === "1" ? (
                    <Typography>{column.bez}</Typography>
                  ) : (
                    <TableSortLabel
                      active={orderby === column.key}
                      direction={order}
                      onClick={() => setze_orderby(column.key)}
                    >
                      {column.bez}
                    </TableSortLabel>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {stableSort(tbl_zeilen, getComparator(order, orderby,tbl_spalten.find((e)=>e.key===orderby)))
              .filter((element) => fitlerByType(element))
              .map((zeile, zeilen_count) => (
                <TableRow
                  key={zeile.key}
                  selected={auswahlZeile === zeile.key}
                  hover={zeilenklickbar}
                  onClick={(e) => klick_event(e, "zeile", zeile.key)}
                  style={{
                    cursor: zeilenklickbar && "pointer",
                    backgroundColor: zeile.zeilenBackColor,
                  }}
                >
                  {tbl_spalten.map((column) => {
                    var zeichen_zeile = "";
                    var value = zeile[column.key];
                    var backColor = "";
                    var chipColor="";
                    if (typeof value === "object") {
                      value = zeile[column.key].text;
                      backColor = zeile[column.key].backColor;
                    }
                    if (zeile[column.key]?.bez) {
                      value = zeile[column.key]?.bez;
                    }
                    if (zeile?.color) {
                      chipColor = zeile.color;
                    }
                    var verbinden = 0;
                    if (zeile[column.key]?.verbinden) {
                      verbinden = zeile[column.key]?.verbinden;
                    }
                    var status_wert = zeile[column.key]?.status;
                    var status_bez = zeile[column.key]?.bez;
                    var disabled = zeile[column.key]?.disabled;
                    verbunden.current = zeile[column.key]?.verbinden
                      ? Number(zeile[column.key]?.verbinden)
                      : Number(verbunden.current) - 1;
                    switch (column.art) {
                      case "chip":
                        zeichen_zeile = (
                          <TableCell colSpan={verbinden}>
                            <Chip
                              size="small"
                              label={value}
                              variant="outlined"
                              style={{
                                backgroundColor:
                                  theme.palette.blocks[chipColor],
                              }}
                            />
                          </TableCell>
                        );
                        break;
                      case "checkbox":
                        zeichen_zeile = (
                          <TableCell colSpan={verbinden}>
                            <Checkbox
                              key={zeile?.key + column.key}
                              icon={
                                <CheckBoxOutlineBlankIcon fontSize="small" />
                              }
                              checkedIcon={<CheckBoxIcon fontSize="small" />}
                              checked={value === "1"}
                              disabled={column?.disabled === "J"}
                              onChange={(e) => {
                                klick_event(
                                  e,
                                  column.key,
                                  zeile.key,
                                  zeilen_count
                                );
                              }}
                            />
                          </TableCell>
                        );
                        break;

                      case "button":
                        switch (column.typ) {
                          case "loeschen":
                            zeichen_zeile = (
                              <TableCell colSpan={verbinden}>
                                <IconButton
                                  key={zeile?.key + column.key}
                                  color="primary"
                                  disabled={disabled === "J"}
                                  onClick={(e) =>
                                    klick_event(e, column.key, zeile.key)
                                  }
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell>
                            );
                            break;
                          case "ansicht":
                            zeichen_zeile = (
                              <TableCell colSpan={verbinden}>
                                <IconButton
                                  key={zeile?.key + column.key}
                                  color="primary"
                                  disabled={disabled === "J"}
                                  onClick={(e) =>
                                    klick_event(e, column.key, zeile.key)
                                  }
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              </TableCell>
                            );
                            break;
                          case "options":
                            zeichen_zeile = (
                              <TableCell colSpan={verbinden}>
                                <IconButton
                                  key={zeile?.key + column.key}
                                  color="primary"
                                  disabled={disabled === "J"}
                                  onClick={(e) =>
                                    klick_event(e, column.key, zeile.key)
                                  }
                                >
                                  <SettingsIcon />
                                </IconButton>
                              </TableCell>
                            );
                            break;
                          case "edit":
                            zeichen_zeile = (
                              <TableCell colSpan={verbinden}>
                                <IconButton
                                  key={zeile?.key + column.key}
                                  color="primary"
                                  disabled={disabled === "J"}
                                  onClick={(e) =>
                                    klick_event(e, column.key, zeile.key)
                                  }
                                >
                                  <EditIcon />
                                </IconButton>
                              </TableCell>
                            );
                            break;
                          default:
                            zeichen_zeile = (
                              <TableCell colSpan={verbinden}>
                                <Button
                                  key={zeile?.key + column.key}
                                  color="primary"
                                  disabled={disabled === "J"}
                                  variant="contained"
                                  fullWidth
                                  onClick={(e) =>
                                    klick_event(e, column.key, zeile.key)
                                  }
                                >
                                  {" "}
                                  {column.bez}
                                </Button>
                              </TableCell>
                            );

                            break;
                        }
                        break;
                      case "status":
                        zeichen_zeile = (
                          <TableCell colSpan={verbinden}>
                            <Alert
                              key={zeile?.key + column.key}
                              severity={status_wert}
                            >
                              {status_bez}
                            </Alert>
                          </TableCell>
                        );
                        break;
                      default:
                        if (
                          column?.verbinden === "1" &&
                          !value &&
                          Number(verbunden.current) > 0
                        )
                          return;
                        switch (zeile?.[column.key]?.art) {
                          case "ueberschrift":
                            zeichen_zeile = (
                              <TableCell
                                key={zeile?.key + column.key}
                                colSpan={verbinden}
                                color="secondary"
                                style={{ backgroundColor: backColor }}
                              >
                                <Typography
                                  autoFocus={zeile?.[column.key]?.focus}
                                  variant={
                                    zeile?.[column.key]?.typ
                                      ? zeile?.[column.key]?.typ
                                      : ""
                                  }
                                >
                                  {value}
                                </Typography>
                              </TableCell>
                            );
                            break;
                          case "button":
                            zeichen_zeile = (
                              <TableCell colSpan={verbinden}>
                                <Button
                                  key={zeile?.key + column.key}
                                  color={
                                    zeile?.[column.key]?.farbe === "secondary"
                                      ? "default"
                                      : "primary"
                                  }
                                  disabled={disabled === "J"}
                                  variant="contained"
                                  fullWidth
                                  onClick={(e) =>
                                    klick_event(
                                      e,
                                      zeile?.[column.key]?.buttonkey
                                        ? zeile?.[column.key]?.buttonkey
                                        : column.key,
                                      zeile?.[column.key]?.key
                                        ? zeile?.[column.key]?.key
                                        : zeile.key
                                    )
                                  }
                                >
                                  {" "}
                                  {value}
                                </Button>
                              </TableCell>
                            );
                            break;
                          case "buttontext":
                            zeichen_zeile = (
                              <TableCell colSpan={verbinden}>
                                <Button
                                  id={zeile?.[column.key]?.id}
                                  key={zeile?.key + column.key}
                                  color={
                                    zeile?.[column.key]?.focus
                                      ? "primary"
                                      : "default"
                                  }
                                  autoFocus={zeile?.[column.key]?.focus}
                                  variant={
                                    zeile?.[column.key]?.focus
                                      ? "outlined"
                                      : "text"
                                  }
                                  fullWidth
                                >
                                  {" "}
                                  {value}
                                </Button>
                              </TableCell>
                            );
                            break;
                          default:
                            zeichen_zeile = (
                              <TableCell
                                style={{ backgroundColor: backColor }}
                                key={zeile?.key + column.key}
                                colSpan={verbinden}
                              >
                                {value}
                              </TableCell>
                            );
                            break;
                        }
                        break;
                    }
                    return zeichen_zeile;
                  })}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const suche_gesamt = () => {
    return (
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={3}>
              <TextField
                select
                variant="outlined"
                label={t("Textsuche in Spalte")}
                value={suchenach}
                onChange={(event) => setSucheNach(event.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
              >
                <MenuItem value={"keineAuswahl"}>{"Alle"}</MenuItem>
                {tbl_spalten?.map((column) => {
                  if (column.art !== "button" && column.art !== "status") {
                    return <MenuItem value={column.key}>{column.bez}</MenuItem>;
                  }
                })}
              </TextField>
            </Grid>
            <Grid item xs={9}>
              <TextField
                variant="outlined"
                label={t("Textsuche")}
                value={textsuche}
                onChange={(event) => setTextSuche(event.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const pruefe_suche = () => {
    if (suche === "GESAMT" && tbl_spalten) {
      return suche_gesamt();
    }
  };
  return (
    <Fragment>
      {title !== "" && <Typography color="primary">{title}</Typography>}
      {tbl_zeilen.length > 0 && suche === "GESAMT" && pruefe_suche()}
      <div ref={refTabelle} style={{ height: div_hoehe, width: "100%" }}>
        {tbl_zeilen.length > 0 ? (
          buildGrid()
        ) : (
          <Typography>{keineZeilen}</Typography>
        )}
        {options?.mehrladen && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => buttonCb("weniger_laden", "")}
          >
            {t("100 Einträge vor")}
          </Button>
        )}
        {options?.wenigerladen && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => buttonCb("mehr_laden", "")}
          >
            {t("100 Einträge zurück")}
          </Button>
        )}
      </div>
    </Fragment>
  );
}
export default DynamicTable;
